import { Printer, X } from "lucide-react";
import { Button } from "@/components/ui/button";

export const SelectionBar = ({ count, onPrint, onClear }) => {
  if (!count) return <p className="h-9 flex items-center text-xs text-[#6E665D] mb-3" data-testid="selection-hint">Click a bottle number to select it for labels · double-click to open the bottle.</p>;
  return (
    <div className="h-9 flex items-center gap-3 mb-3" data-testid="selection-bar">
      <span className="text-sm text-[#D4AF37]" data-testid="selection-count">{count} selected</span>
      <Button size="sm" onClick={onPrint} className="bg-[#D4AF37] hover:bg-[#E5A93C] text-[#0D0A0B]" data-testid="print-selected-button"><Printer className="w-3.5 h-3.5 mr-2" />Print {count} label{count > 1 ? "s" : ""}</Button>
      <Button size="sm" variant="ghost" onClick={onClear} data-testid="clear-selection-button"><X className="w-3.5 h-3.5 mr-1" />Clear</Button>
    </div>
  );
};

export const toggleIn = (setter) => (b) => setter((s) => (s.includes(b.barcode) ? s.filter((x) => x !== b.barcode) : [...s, b.barcode]));
